import { render } from "./Nssf.vue?vue&type=template&id=2be0c5b2"
import script from "./Nssf.vue?vue&type=script&lang=js"
export * from "./Nssf.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__